import 'one-ui-styles';
import './less/index.less';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// IE compatibility
import 'one-web-ie11';

// Context provider
import {
   Provider,
} from 'one-ui-provider';

// App component
import {
   App,
} from './app';

import {
   Actions,
   Action as VoiceAction
} from 'one-state-interact-voice';


// Redux store
import {
   build,
} from '../one-store/index';

/**
 * Entry point into the application
 * @param root - id of the root element (dom)
 * @param context - application specific data (like settings etc.)
 * @returns - Promise that resolves once the initialization is complete
 */
export const init = (root: string, context: any): Promise<any> => (
   new Promise<any>((resolve: any) => {
      const store = build(
         context,
      );
      (window as any).store = store; // Attach to window for global access
      const app = (
         <Provider
            store={store}
            context={context}
         >
            <App />
         </Provider>
      );

      // Render the compnent
      // Resolve the promise once the rendering
      // is complete
      ReactDOM.render(
         app,
         document.getElementById(
            root,
         ),
         () => {
            // done initializing
            // return the store
            resolve({
               store,
                    // update state on voice events
                    voice: (event: Event): void => {
                     const action: VoiceAction<Actions> = {
                         payload: event,
                         type: Actions.SET,
                     };
                     store.dispatch(action);
                 },
            });
         },
      );
   })
);
